
import Ship from "../../../assets/duotone/Ship.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShipIcon({ className, dataTestid = "ShipIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ship data-testid={dataTestid} className={classes} {...rest} />
  );
}
